import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Ad Aggregation
 */
export class AdAggregationValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.id
   * @param {Number} deps.totalResults
   */
}
